import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO: relay to query for the current count of entities based on the applied
 * params
 */
export const executeCountMatches = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.countMatches.relay(forwardTo =>
      feature.selectors.queryRequestThatAffectsMatchedCount.asObservable.pipe(
        // NOTE: this ensures the relay is closed after we get the current query
        // request that affects matched count
        rxjs.take(1),
        rxjs.map(request =>
          forwardTo(
            plugin.collection.plugins.dataOperationPlugin.feature.actions.count,
            {
              input: request,
              output: ({ response: matchedCount }) => ({
                matchedCount,
              }),
            },
          ),
        ),
      ),
    ).asObservable,
)
